import { useEffect, useContext } from "react";
import { UserContext } from "@/shared/contexts/user.context";

interface GoogleAnalyticsProps {
  measurementId?: string;
}

// Function to get user properties for analytics
const getUserProperties = (user: any) => {
  if (!user) {
    return {
      userType: "anonymous",
    };
  }

  if (user.isAdmin) {
    return {
      userType: "admin",
    };
  }

  return {
    userType: "candidate",
  };
};

export const GoogleAnalyticsUserIdent: React.FC<GoogleAnalyticsProps> = ({
  measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID,
}) => {
  const { user } = useContext(UserContext);

  useEffect(() => {
    if (measurementId && window.gtag) {
      const userProperties = getUserProperties(user);
      window.gtag("set", userProperties);
    }
  }, [measurementId, user]);

  return null;
};
